import React from 'react';
import dateformat from 'dateformat';

import {UPCOMING_KEY, CANCELLED_KEY, COMPLETED_KEY, FAILED_KEY} from '@ibibo/myaccount-reducer';
import IconSelector from '@ibibo/icon-selector';

import * as S from './DetailsHeader.styles';

import BreadCrumb from '../../common/BreadCrumb/BreadCrumb';

const DetailsHeader = ({headerDetails}) => {
  const {tripType, bookingStatusText, detailText, detailSubText, bookingId, pnr, booking_datetime} = headerDetails;
  const status = tripType.toLowerCase();

  const StateImg = () => {
    switch(status) {
      case UPCOMING_KEY:
        return <IconSelector iconKey='detailconfirmed' />;
      case CANCELLED_KEY:
        return <IconSelector iconKey='detailcancelled' />;
      case FAILED_KEY:
        return <IconSelector iconKey='detailFailed' />;
      case COMPLETED_KEY:
        return <IconSelector iconKey='detailcompleted' />;
      default:
        return <IconSelector iconKey='detailcancelled' />;
    }
  }

  const bkngDate = new Date(booking_datetime.replace(/ /g,"T"));

  return(
    <S.HeaderMainWrap>
      <S.HeaderStatusBack status={status}>
        <S.HeaderDetailOuterWrap>
          <S.HeaderDetailInnerWrap>
            <BreadCrumb />
            <S.HeaderBkngDetailsWrap>
              <S.HeaderBkngStatus>{detailText}</S.HeaderBkngStatus>
              <S.HeaderSubBkngStatus>{detailSubText}</S.HeaderSubBkngStatus>
              <S.HeaderBkngInfoWrap>
                <S.HeaderBkngId>Booking ID: <span>{bookingId}</span></S.HeaderBkngId>
                {(pnr && <S.HeaderBkngId>PNR: <span>{pnr}</span></S.HeaderBkngId>) || null}
                {(booking_datetime && <S.HeaderBkngId>Booking Date: <span>{dateformat(bkngDate, 'dd mmm \'yy')}</span></S.HeaderBkngId>) || null}
              </S.HeaderBkngInfoWrap>
            </S.HeaderBkngDetailsWrap>
            <S.HeaderStateImgWrap>
              <StateImg />
            </S.HeaderStateImgWrap>
          </S.HeaderDetailInnerWrap>
        </S.HeaderDetailOuterWrap>
      </S.HeaderStatusBack>
    </S.HeaderMainWrap>
  );
}

export default DetailsHeader;